import { CSSProperties, FC, ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { SelectOptionsDropdown } from "@ryde/controls";
import {
  allCoursesCalendarSlotIdsSelector,
  allRecordsSelectedCoursesCalendarSelector,
  selectedCoursesCalendarSlotIdsAtom,
  SelectionEnum,
  setCheckedHandlerCoursesCalendarSlots,
} from "@ryde/shared";

interface ICorner {
  style: CSSProperties;
}

export const CoursesCalendarCornerCell: FC<ICorner> = ({
  style,
}): ReactElement => {
  const { t } = useTranslation();
  const setSelectedSlotIds = useSetRecoilState(
    selectedCoursesCalendarSlotIdsAtom,
  );
  const allSlotIds = useRecoilValue(allCoursesCalendarSlotIdsSelector);
  const selectedState = useRecoilValue(
    allRecordsSelectedCoursesCalendarSelector,
  );

  const onSetChecked = (value: SelectionEnum): void => {
    setCheckedHandlerCoursesCalendarSlots[value]({
      setter: setSelectedSlotIds,
      slotIds: allSlotIds,
    });
  };

  return (
    <div className="cc-first-cell" style={style}>
      <SelectOptionsDropdown
        checked={selectedState}
        setChecked={onSetChecked}
      />
      <span className="title">{t("course.calendar.hourColumn")}</span>
    </div>
  );
};
